
const NoChatSelected = () => {
    return (
        <div 
            className="chatbox" 
            style={{
                // border: '1px solid red',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '36px',
                color: '#dedede'
            }}
        >
            No Chat Selected
        </div>
    )
}

export default NoChatSelected
